import { BREADCRUMBS, SLIDING_PANEL_STATE_KEY } from "./reducer";

const _getModuleState = (state) => state[SLIDING_PANEL_STATE_KEY];

export const getBreadcrumbs = (state) => _getModuleState(state)[BREADCRUMBS];
